import { Controller } from "@hotwired/stimulus"

// Drives the combined "build" onboarding step (relative weight + gender).
// Marks the tapped option as selected and only enables Next once both
// questions have an answer.
export default class extends Controller {
  static targets = ["submit", "input", "option"]

  connect() {
    this.onChange()
  }

  onChange() {
    this.optionTargets.forEach((option) => {
      const input = option.querySelector("input[type=radio]")
      option.classList.toggle("--selected", input.checked)
    })

    this.bothAnswered() ? this.enableSubmit() : this.disableSubmit()
  }

  bothAnswered() {
    return this.groupChecked("relative_weight") && this.groupChecked("gender")
  }

  groupChecked(field) {
    // Match the field regardless of form scope (student[...] on the account
    // editor, profile[...] in anonymous onboarding).
    return this.inputTargets.some(
      (input) => input.name.endsWith(`[${field}]`) && input.checked
    )
  }

  disableSubmit() {
    this.submitTarget.disabled = true
    this.submitTarget.classList.add("--disabled")
  }

  enableSubmit() {
    this.submitTarget.disabled = false
    this.submitTarget.classList.remove("--disabled")
  }
}
